import { createSelector } from 'reselect';
import _ from 'underscore';

/**
 * Create a dynamic selectors from parameters
 * @param {object} params
 * @param {string} params.reducerName Reducer name ie. 'APIEvents'
 */
export default function RessourceSelectorsFactories(params) {
    const selectors = {};
    // Get a specific item from a filter
    selectors.getItemSelector = (state, filter) => (
        _.find(state[params.reducerName].items, filter)
    );
    // Get all items
    selectors.getItemsSelector = (state, filter) => (
        _.filter(state[params.reducerName].items, filter)
    );
    // Is loading
    selectors.isLoadingSelector = (state) => (
        state[params.reducerName].isLoading
    );
    // Get count
    selectors.getCountSelector = (state) => (
        state[params.reducerName].count
    );
    // Get page
    selectors.getPageSelector = (state) => (
        state[params.reducerName].page
    );
    // Get page size
    selectors.getPageSizeSelector = (state) => (
        state[params.reducerName].pageSize
    );
    // Get current items
    selectors.getCurrentItemsSelector = createSelector(
        [
            selectors.getPageSelector,
            selectors.getPageSizeSelector,
            selectors.getItemsSelector,
        ],
        (page, pageSize, items) => items.slice(
            (page - 1) * pageSize,
            page * pageSize,
        ),
    );
    return selectors;
}

export function rawSelector(reducerKey, key, state) {
    return state[reducerKey][key];
}

/**
 * Generate the raw selectors of a reducer
 * @param {object} initialState
 * @param {string} reducerKey
 * @returns {object} selectors object
 */
export function generateRawSelectors(initialState, reducerKey) {
    const selectors = {};
    Object.keys(initialState).forEach((key) => {
        const selectorName = `get${key.charAt(0).toUpperCase()}${key.slice(1)}Selector`;
        selectors[selectorName] = rawSelector.bind(null, reducerKey, key);
    });
    return selectors;
}
